import PageHero from "../components/PageHero";
import SEO from "../components/SEO";
import { faqSchema } from "../components/seoSchemas";
import { faqs, site } from "../data/site";

export default function FAQPage() {
  return (
    <>
      <SEO
        title="FAQ | Polishing Singapore"
        description="Common questions about marble, granite, quartz, terrazzo, tile, parquet, concrete and natural stone polishing and restoration in Singapore."
        canonical={`${site.domain}/faq`}
        jsonLd={faqSchema()}
      />
      <PageHero title="Frequently Asked Questions" description="Straight answers about stone, tile, parquet and concrete polishing or restoration work." image="/assets/polishing/service_tile_grout.webp" />
      <section className="section-pad bg-background-50">
        <div className="section-shell max-w-4xl">
          <div className="grid gap-4">
            {faqs.map((faq) => (
              <article key={faq.question} className="surface-card p-6">
                <h2 className="font-heading text-2xl font-bold">{faq.question}</h2>
                <p className="mt-3 text-base leading-8 text-foreground-700">{faq.answer}</p>
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
